import {
  MenuBook as BookOpen,
  SmartToy as Bot,
  People as Characters,
  Dashboard,
  Event as Events,
  LibraryBooks as Library,
  LocationOn as Locations,
  EditNote as NotebookPen,
  Business as Organizations,
  Hub as Relationships,
  AutoStories as Storyboard,
  AccountTree as Timeline
} from '@mui/icons-material';
import React from 'react';

export interface NavItem {
  href: string;
  label: string;
  icon: React.ElementType;
  flag?: string;
}

export const navItems: Record<string, NavItem[]> = {
  main: [
    { href: '/', label: 'sidebar.dashboard', icon: Dashboard },
    { href: '/editor', label: 'sidebar.novel_editor', icon: BookOpen },
    { href: '/library', label: 'sidebar.library', icon: Library },
  ],
  workspace: [
    { href: '/narrative-structure', label: 'sidebar.outline_structure', icon: Timeline, flag: 'should_display_outline_page' },
    { href: '/scenes', label: 'sidebar.scenes', icon: BookOpen },
    { href: '/arcs', label: 'sidebar.arcs', icon: BookOpen, flag: 'should_display_arcs_page' },
    { href: '/storyboard', label: 'sidebar.storyboard', icon: Storyboard, flag: 'should_display_storyboard_page' },
  ],
  worldBuilding: [
    { href: '/characters', label: 'sidebar.characters', icon: Characters },
    { href: '/organizations', label: 'sidebar.organizations', icon: Organizations },
    { href: '/locations', label: 'sidebar.geography', icon: Locations },
    { href: '/events', label: 'sidebar.events', icon: Events },
    { href: '/codex', label: 'sidebar.codex', icon: Library, flag: 'should_display_codex_page' },
  ],
  planningTools: [
    { href: '/timeline', label: 'sidebar.timeline', icon: Bot, flag: 'should_display_timeline_page' },
    { href: '/relationships', label: 'sidebar.relationship_map', icon: Relationships },
  ],
  other: [
    { href: '/notes', label: 'sidebar.research_notes', icon: NotebookPen, flag: 'should_display_research_and_notes_page' },
    { href: '/import', label: 'sidebar.import_material', icon: NotebookPen, flag: 'ai_assistance_allowed' },
  ]
};
